import React, { useState } from "react"
import { useSelector } from "react-redux"
import {
    PaymentElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js"

import { PAYMENT_CURRENCY } from "const"
import { mtBillingRoute, completePaymentRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import {
    SpinnerIcon,
    Button,
    Feedback,
} from "client/components"

import { PaymentMessage } from "client/pages/mt/billing/styled"
import {
    SubmitForm,
    SubmitButton,
    CancelButtonWrapper,
} from "./styled"

interface CheckoutFormProps {
    totalPrice: number
    onBack: () => void
    onCancel: () => void
}

const CheckoutForm = ({
    totalPrice,
    onBack,
    onCancel,
}: CheckoutFormProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const stripe = useStripe()
    const elements = useElements()

    const [submitInProgress, setSubmitInProgress] = useState<boolean>(false)
    const [message, setMessage] = useState(null)

    const handleSubmit = () => {
        if (!stripe || !elements) return
        setSubmitInProgress(true)

        stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}${mtBillingRoute}${completePaymentRoute}`,
            },
        }).then(({ error }) => {
            if (error) {
                if (error.type === "card_error" || error.type === "validation_error") {
                    setMessage(error.message)
                } else {
                    setMessage("An unexpected error occurred.")
                }
                setSubmitInProgress(false)
            }
        })
    }

    return (
        <SubmitForm>
            <PaymentElement
                id="payment-element"
                options={{
                    layout: {
                        type: "tabs",
                        defaultCollapsed: false,
                    },
                }}
            />
            <SubmitButton onClick={handleSubmit}>
                {
                    submitInProgress
                        ? <SpinnerIcon />
                        : `${lang.pay} ${totalPrice} ${PAYMENT_CURRENCY}`
                }
            </SubmitButton>


            {
                message && (
                    <PaymentMessage>
                        <Feedback>{message}</Feedback>
                    </PaymentMessage>
                )
            }

            <CancelButtonWrapper>
                <Button onClick={onBack}>{lang.back}</Button>
                <Button onClick={onCancel}>{lang.cancelOrder}</Button>
            </CancelButtonWrapper>
        </SubmitForm>
    )
}
export default CheckoutForm
